<template>
  <div class="d-flex flex-column flex-center pb-20">
    <img
      src="media/error/under-construction.png"
      class="w-400px no-select"
      alt="under-construction">
    <div class="h4 font-weight-normal text-dark-50">
      {{ message }}
    </div>
  </div>
</template>

<script>
import { GLOBAL_WORDS } from '@/core/services/store/config.module.js'

export default {
  name: 'UnderConstruction',
  data() {
    return {
      message: GLOBAL_WORDS['work_in_progress']
    }
  },
  mounted() {
    
  },
}
</script>
